import { Component } from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from './services/authentication.service';
import {tokenNotExpired} from 'angular2-jwt';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public router: Router, private _authService: AuthenticationService) {
  }

  public isAdmin(): boolean {
    if (this._authService.user && this._authService.user.role === 'admin') {
      return true;
    }

    return false;
  }

  public logout(): void {
    this._authService.logout();
    this.router.navigate(['/login']);
  }

  public isLoggedIn(): boolean {
    return tokenNotExpired('id_token');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts